module.exports = __webpack_public_path__ + "media/images/farey/farey_small_expert_cession-3fd301dd8ff880c2f15aa20390094f97.png";